module.exports = __webpack_public_path__ + "static/media/S1_00035.2cd03199.jpg";